import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { ModerationDetail } from '../types';
import { Field, TextBlock } from '../components/DetailField';

// Feedback summary (doc 09 §4.5, FEEDBACK only). The reporter is the feedbacker; the body is the
// feedback text. Attachments render in their own card.
export function FeedbackSummaryCard({ report }: { report: ModerationDetail }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">Feedback Summary</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="divide-y">
          <Field label="Category">{report.reason}</Field>
        </div>
        {report.description && <TextBlock label="Feedback" value={report.description} />}
        {report.useCase && <TextBlock label="Additional Notes" value={report.useCase} />}
      </CardContent>
    </Card>
  );
}
